import {
  IvsApiConstants,
  type ApolloClientOptionalOptions,
} from '@trp-dms-digital-shared/ds-ui-library-api';

// actual API key - we need a .env solution
const APIKEY_PROD = 'lhiKZfzAAJX3bpABwQknSzBXSKic6OaC';

// endpoints generated & owned by ds-ui-library
const ENDPOINT_PROD = IvsApiConstants.ENDPOINT_PROD.toString();

// unique default setup for ivs-api-base
const CLIENT_DEFAULT_OPTS: ApolloClientOptionalOptions = {
  name: 'ivs-api-service',
  ssrMode: true,
  ...IvsApiConstants.CLIENT_DEFAULT_OPTS,
  headers: {
    ...IvsApiConstants.CLIENT_DEFAULT_OPTS.headers,
    apikey: APIKEY_PROD,
  },
  uri: ENDPOINT_PROD,
};

export const Constants = {
  TAG_NAME: 'pop-ivs-api-base-component',
  DATA_FRAGMENT: 'data-fragment',
  DATA_TICKER: 'data-ticker',
  DATA_QUERY_TYPE: 'data-query-type',
  POPCONFIG_ENDPOINT: 'ivs-endpoint',
  POPCONFIG_APIKEY: 'ivs-apikey',
  CLIENT_DEFAULT_OPTS,
  // need DEV apikey, so points to prod
  // ENDPOINT_DEV: IvsApiConstants.ENDPOINT_DEV.toString(),
  ENDPOINT_DEV: ENDPOINT_PROD,
  ENDPOINT_STAGE: IvsApiConstants.ENDPOINT_STAGE.toString(),
  ENDPOINT_PROD,
  // need DEV apikey, this is PROD api key
  APIKEY_DEV: APIKEY_PROD,
  APIKEY_STAGE: 'do-not-have',
  APIKEY_PROD,
  QUERY_TYPES: IvsApiConstants.QUERY_TYPES,
  LOG_PREFIX: 'IVS-API-BASE: ',
} as const;
